/* eslint-disable no-param-reassign */
export default (data) => ({
  organizations: data,
  organizationsById: data?.reduce((organizations, organization) => {
    organizations[`id-${organization.id}`] = organization;
    return organizations;
  }, {}),
});
